import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { NumsiList } from './NumsiList';
import { NonActivatedSimsList } from './NonActivatedSimsList';

export class NonActivatedSimsFeatures extends React.Component {
	// eslint-disable-line react/prefer-stateless-function
	render() {
		const { nonActivatedSims, offeringType } = this.props;
		return (
			<div>
				{nonActivatedSims && <NumsiList subscriptions={_.filter(nonActivatedSims, (sim) => sim.mnpInfoMissing && sim.simMapped)} />}
				{!_.isNil(nonActivatedSims) && nonActivatedSims.length > 0 && <NonActivatedSimsList nonActivatedSims={nonActivatedSims} offeringType={offeringType} />}
			</div>
		);
	}
}

NonActivatedSimsFeatures.propTypes = {
	nonActivatedSims: PropTypes.array
};

export default NonActivatedSimsFeatures;
